import {cerrarSesion} from '../utilities/Seguridad'
import moment from 'moment';

const axios = require('axios');
const FormData = require('form-data');
const fs = require('fs');
const qs = require('qs');

export async function updatePersona(persona, token) {

  let data = qs.stringify({
    'run': persona.run,
    'nombres': persona.nombres,
    'apellido_paterno': persona.apellido_paterno,
    'apellido_materno': persona.apellido_materno,
    'genero': persona.genero === undefined ? null : persona.genero.code,
    'idPais': persona.pais === undefined ? null : persona.pais.id,
    'direccion': persona.direccion,
    'email': persona.email,
    'telefono': persona.telefono,
    'fecha_nacimiento': persona.fecha_nacimiento==''?persona.fecha_nacimiento:moment(persona.fecha_nacimiento).format("YYYY-MM-DD"),
    'idComuna': persona.comuna === undefined ? null : persona.comuna.idcomuna,
    'idIdioma': persona.idioma === undefined ? null : persona.idioma.id,
    'idEtnia': persona.etnia === undefined ? null : persona.etnia.id,
    'fecha_ingreso':persona.fecha_ingreso==''?persona.fecha_ingreso: moment(persona.fecha_ingreso).format("YYYY-MM-DD"),
    'fecha_retiro': persona.fecha_retiro==''?persona.fecha_retiro:moment(persona.fecha_retiro).format("YYYY-MM-DD"),
    'prioritario': persona.prioritario?1:0,
    'preferente': persona.preferente?1:0
  });

  let config = {
    method: 'put',
    url: `${process.env.REACT_APP_URL}/alumno/${persona.id}`,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: data
  };

  const response = await axios(config)
    .then((response) => {
      if(response.data.error===1) cerrarSesion(response.data);
      return response.data;

    })
    .catch((error) => {
      console.log(error);
      return null;

    });

  return response;

}

export async function updatePersonaApoderado(persona, token) {

  let data = qs.stringify({
    'run': persona.run,
    'nombres': persona.nombres,
    'apellido_paterno': persona.apellido_paterno,
    'apellido_materno': persona.apellido_materno,
    'direccion': persona.direccion,
    'email': persona.email,
    'telefono1': persona.telefono1,
    'telefono2': persona.telefono2,
    'numero_emergencia': persona.numero_emergencia,
    'fecha_nacimiento': persona.fecha_nacimiento==''?persona.fecha_nacimiento: moment(persona.fecha_nacimiento).format("YYYY-MM-DD"),
    'idcomuna': persona.comuna === undefined ? null : persona.comuna.idcomuna,
    'idparentesco': persona.parentesco === undefined ? null : persona.parentesco.id

  });

  let config = {
    method: 'put',
    url: `${process.env.REACT_APP_URL}/alumno/${persona.idalumno}/apoderado`,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: data
  };

  const response = await axios(config)
    .then((response) => {
      if(response.data.error===1) cerrarSesion(response.data);
      return response.data;

    })
    .catch((error) => {
      console.log(error);
      return null;

    });

  return response;

}

export async function updatePersonaGlosa(glosa, token) {

  let data = qs.stringify({
    'glosa': glosa.glosa
  });

  let config = {
    method: 'put',
    url: `${process.env.REACT_APP_URL}/alumno/${glosa.idalumno}/glosa`,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: data
  };

  const response = await axios(config)
    .then((response) => {
      if(response.data.error===1) cerrarSesion(response.data);
      return response.data;

    })
    .catch((error) => {
      console.log(error);
      return null;

    });

  return response;

}

export async function getPersona(idPersona, token) {

  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_URL}/alumno/${idPersona}`,
    headers: {
      'Authorization': `Bearer ${token}`,
    }
  };

  const response = await axios(config)
    .then((response) => {
      if(response.data.error===1) cerrarSesion(response.data);
      return response.data;

    })
    .catch((error) => {
      console.log(error);
      return null;

    });

  return response;

}

export async function setUploadFoto(idPersona, file, token) {

  let data = new FormData();
  //data.append('imagen', fs.createReadStream(pathFoto));
  data.append('imagen', file);
  let config = {
    method: 'put',
    url: `${process.env.REACT_APP_URL}/alumno/${idPersona}/imagen`,
    headers: {
      'Authorization': `Bearer ${token}`,
      ...data
    },
    data: data
  };

  const response = await axios(config)
    .then((response) => {
      if(response.data.error===1) cerrarSesion(response.data);
      return response.data;
    })
    .catch((error) => {
      error['error'] = 1;
      error['mensaje'] = error.message;
      return error;
    });
  return response;
}

